import { Box, Collapse, Grid, useTheme } from '@mui/material'
import { ICustomer } from '../../../generated-types'
import { AppRoutesNavigation } from '../../../app-routes'
import { useNavigate } from 'react-router-dom'
import { IServiceStation } from '../../../generated-types/service-station'
import ServiceStationCard from './ServiceStationCard'
import { CustomerHeader } from 'src/components/sidemenu/CustomerHeader'
import { EmptyStatusCard } from 'src/components/mooring/EmptyStatusCard'
import { useTranslation } from 'react-i18next'
import NoServiceStationCustomers from '../../../assets/svg/no-service-station-customers.svg'
import NoServiceStations from '../../../assets/svg/no-locality-content.svg'
import { getThemeColor } from 'src/utils'
import { MUIThemeColors } from 'src/mui-theme'

const AllServiceStations: React.FC<{
  customers: ICustomer[] | undefined
  open: number
  setOpen: (value: any) => void
}> = ({ customers, open, setOpen }) => {
  const navigate = useNavigate()
  const { t: translate } = useTranslation(['service-station'])
  const theme = useTheme()
  return (
    <Box height={'100%'} maxHeight={window.innerHeight - 162} overflow={'auto'}>
      {customers?.length === 0 ? (
        <Box
          py={8}
          className="text-center"
          height={'100%'}
          bgcolor={getThemeColor(theme, MUIThemeColors.white)}
          border={'1px solid #d8e1e7;'}
        >
          <EmptyStatusCard
            imageWidth="132px"
            image={NoServiceStationCustomers}
            header={translate('service-station-empty-status-title', { ns: 'service-station' })}
            content={translate('service-station-empty-status-content', { ns: 'service-station' })}
            headerFontSize="18px"
            contentFontSize="14px"
            contentTopMargin="10px"
            imageContainerClasses="pb-4"
            height="100%"
            contentClasses="mt-1"
          />
        </Box>
      ) : (
        customers?.map((customer: ICustomer, index: number) => {
          // Don't display customer if no service stations
          if (customer.serviceStations.length === 0) return <></>

          return (
            <Box key={index}>
              <Box padding={0.5}>
                <CustomerHeader
                  hasAdminAccess={customer.isAdminCustomer}
                  isLandingPage={true}
                  {...customer}
                  onClick={() => {
                    localStorage.setItem('currentCustomerId', customer.id.toString())
                    if (customer.isAdminCustomer)
                      localStorage.setItem('selectedCustomerAdminCustomerId', customer.id.toString())
                    setOpen(value => (value == customer.id ? 0 : customer.id))
                  }}
                  active={open == customer.id}
                  isServiceStation={true}
                />
              </Box>
              <Collapse
                in={open == customer.id}
                sx={{ paddingTop: '12px', paddingBottom: '16px', paddingLeft: '4px', paddingRight: '4px' }}
              >
                {customer.serviceStations.length != 0 ? (
                  <Grid container className="overflow-y-auto " maxHeight={'82vh'} spacing={'11px'}>
                    {customer.serviceStations?.map((serviceStation: IServiceStation, index: number) => {
                      return (
                        <Grid item md={3} xs={6} key={index}>
                          <ServiceStationCard
                            serviceStation={serviceStation}
                            active={true}
                            onClick={() => {
                              navigate(
                                AppRoutesNavigation.serviceStation.serviceStation(
                                  serviceStation.customerId,
                                  serviceStation.id,
                                ),
                              )
                            }}
                          />
                        </Grid>
                      )
                    })}
                  </Grid>
                ) : (
                  <Box py={8} className="text-center" height={'100%'}>
                    <EmptyStatusCard
                      imageWidth="132px"
                      image={NoServiceStations}
                      header={translate('customer-service-station-empty-status-title', { ns: 'service-station' })}
                      content={translate('customer-service-station-empty-status-content', { ns: 'service-station' })}
                      headerFontSize="18px"
                      contentFontSize="14px"
                      contentTopMargin="10px"
                      imageContainerClasses="pb-4"
                      height="100%"
                      contentClasses="mt-1"
                    />
                  </Box>
                )}
              </Collapse>
            </Box>
          )
        })
      )}
    </Box>
  )
}

export default AllServiceStations
